import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { tap, map } from 'rxjs/operators'; 
import { Stream } from 'src/models/stream';
import { Observable } from 'rxjs';
import { Genre } from 'src/models/genre';
import { Country } from 'src/models/country';

@Injectable({
  providedIn: 'root'
})
export class StreamService {

  private apiURL = '/main/index';


  constructor(private httpClient: HttpClient) { }

  public getTopStations(start: number, limit: number): Observable<Stream[]> {

    return this.httpClient.post<Stream[]>((`${this.apiURL}/topStations`), {
      'start': start.toString(),
      'limit': limit.toString()
    }).pipe(map(res => {
      const result = new Array<Stream>();

      const resStreams: Array<object> = res['params']['streams'];

      resStreams.forEach((item: object) => {
          result.push(Stream.fromResponseData(item));
      });

      return result;
    }));
  }

  public getTopStationsInternational(): Observable<Stream[]> {
    return this.httpClient.get<Stream[]>((`${this.apiURL}/topStationsInternational`)).pipe(map(res => {
      const result = new Array<Stream>();

      const resStreams: Array<object> = res['params']['streams'];

      resStreams.forEach((item: object) => {
          result.push(Stream.fromResponseData(item));
      });

      return result;
    }));
  }

  public getTopCategories(): Observable<Genre[]> {
    return this.httpClient.get<Genre[]>((`${this.apiURL}/topGenres`)).pipe(map(res => {
      const result = new Array<Genre>();

      const resStreams: Array<object> = res['params'];

      resStreams.forEach((item: object) => {
          const category = new Genre();

          category.id = item['id'];
          category.name = item['name'];

          result.push(category);
      });

      return result;
    }));
  }

  public getCategories(): Observable<Genre[]> {
    return this.httpClient.get<Genre[]>((`${this.apiURL}/genres`)).pipe(map(res => {
      const result = new Array<Genre>();

      const resStreams: Array<object> = res['params'];

      resStreams.forEach((item: object) => {
          const category = new Genre();

          category.id = item['id'];
          category.name = item['name'];

          result.push(category);
      });

      return result;
    }));
  }

  public getCountriesWithStreams(): Observable<Country[]> {

    return this.httpClient.post<Country[]>((`${this.apiURL}/countriesWithStreams`), { 'lang': 'de' }).pipe(map(res => {
      const result = new Array<Country>();

      const resStreams: Array<object> = res['params'];

      resStreams.forEach((item: object) => {
          const country = new Country();

          country.id = item['id'];
          country.name = item['name'];

          result.push(country);
      });

      return result;
    }));
  }

  public getCountriesWithMusicStations(): Observable<Country[]> {

    return this.httpClient.post<Country[]>((`${this.apiURL}/countriesWithMusicStations`), { 'lang': 'de' }).pipe(map(res => {
      const result = new Array<Country>();

      const resStreams: Array<object> = res['params'];

      resStreams.forEach((item: object) => {
          const country = new Country();

          country.id = item['id'];
          country.name = item['name'];

          result.push(country);
      });

      return result;
    }));
  }

  public getCountriesWithNewsStations(): Observable<Country[]> {

    return this.httpClient.post<Country[]>((`${this.apiURL}/countriesWithNewsStations`), { 'lang': 'de' }).pipe(map(res => {
      const result = new Array<Country>();

      const resStreams: Array<object> = res['params'];

      resStreams.forEach((item: object) => {
          const country = new Country();

          country.id = item['id'];
          country.name = item['name'];

          result.push(country);
      });

      return result;
    }));
  }

  public getCountriesWithSportStations(): Observable<Country[]> {

    return this.httpClient.post<Country[]>((`${this.apiURL}/countriesWithSportStations`), { 'lang': 'de' }).pipe(map(res => {
      const result = new Array<Country>();

      const resStreams: Array<object> = res['params'];

      resStreams.forEach((item: object) => {
          const country = new Country();

          country.id = item['id'];
          country.name = item['name'];

          result.push(country);
      });

      return result;
    }));
  }

  public getStationsByName(search: string, start: number, limit: number): Observable<Stream[]> {

    return this.httpClient.post<Stream[]>((`${this.apiURL}/streamsByName`), {
      'search': search,
      'start': start.toString(),
      'limit': limit.toString()
    }).pipe(map(res => {
      const result = new Array<Stream>();

      const resStreams: Array<object> = res['params']['streams'];

      resStreams.forEach((item: object) => {
          result.push(Stream.fromResponseData(item));
      });

      return result;
    }));
  }

  public getStationsByCategory(category: number, start: number, limit: number): Observable<Stream[]> {

    return this.httpClient.post<Stream[]>((`${this.apiURL}/streamsByCategory`), {
      'categoryId': category.toString(),
      'start': start.toString(),
      'limit': limit.toString()
    }).pipe(map(res => {
      const result = new Array<Stream>();

      const resStreams: Array<object> = res['params']['streams'];

      resStreams.forEach((item: object) => {
          result.push(Stream.fromResponseData(item));
      });

      return result;
    }));
  }

  public getStationsByCountry(country: string, start: number, limit: number): Observable<Stream[]> {

    return this.httpClient.post<Stream[]>((`${this.apiURL}/streamsByCountry`), {
      'countryId': country,
      'start': start.toString(),
      'limit': limit.toString()
    }).pipe(map(res => {
      const result = new Array<Stream>();

      const resStreams: Array<object> = res['params']['streams'];

      resStreams.forEach((item: object) => {
          result.push(Stream.fromResponseData(item));
      });

      return result;
    }));
  }

  public getMusicStationsByCountry(country: string, start: number, limit: number): Observable<Stream[]> {

    return this.httpClient.post<Stream[]>((`${this.apiURL}/musicStreamsByCountry`), {
      'countryId': country,
      'start': start.toString(),
      'limit': limit.toString()
    }).pipe(map(res => {
      const result = new Array<Stream>();

      const resStreams: Array<object> = res['params']['streams'];

      resStreams.forEach((item: object) => {
          result.push(Stream.fromResponseData(item));
      });

      return result;
    }));
  }

  public getNewsStationsByCountry(country: string, start: number, limit: number): Observable<Stream[]> {

    return this.httpClient.post<Stream[]>((`${this.apiURL}/newsStreamsByCountry`), {
      'countryId': country,
      'start': start.toString(),
      'limit': limit.toString()
    }).pipe(map(res => {
      const result = new Array<Stream>();

      const resStreams: Array<object> = res['params']['streams'];

      resStreams.forEach((item: object) => {
          result.push(Stream.fromResponseData(item));
      });

      return result;
    }));
  }

  public getSportsStationsByCountry(country: string, start: number, limit: number): Observable<Stream[]> {

    return this.httpClient.post<Stream[]>((`${this.apiURL}/sportsStreamsByCountry`), {
      'countryId': country,
      'start': start.toString(),
      'limit': limit.toString()
    }).pipe(map(res => {
      const result = new Array<Stream>();

      const resStreams: Array<object> = res['params']['streams'];

      resStreams.forEach((item: object) => {
          result.push(Stream.fromResponseData(item));
      });

      return result;
    }));
  }

  public getStationDetails(streamName: string) {
    return this.httpClient.post<Stream[]>((`${this.apiURL}/stream`), {
      name: streamName
    }).pipe(map(res => {
      return Stream.fromResponseData(res['params']['stream']);
    }));
  }

  public parsePlaylist(stream: Stream): Observable<string[]> {
    return this.httpClient.post<Stream[]>((`${this.apiURL}/parsePlayList`), { streamId: stream.id.toString() }).pipe(map(res => {

      const resStreams: Array<string> = res['params']['streams'];

      return resStreams;
    }));
  }
}
